// extracted by mini-css-extract-plugin
export var buttonLink = "HeaderMenuItem-module--buttonLink--818a6";
export var expandMenu = "HeaderMenuItem-module--expandMenu--ab9b5";
export var menuLink = "HeaderMenuItem-module--menuLink--eadf4";
export var mobileHidden = "HeaderMenuItem-module--mobileHidden--f0661";
export var platformMenu = "HeaderMenuItem-module--platformMenu--12fa4";
export var root = "HeaderMenuItem-module--root--41575";
export var supportMenu = "HeaderMenuItem-module--supportMenu--63707";